// Carrinho da V3 (B4): o que o Dawn não faz em volta do carrinho dele e o Complete o seu veículo.
// GAVETA: o Dawn redesenha o conteúdo o tempo todo — renderContents troca o #CartDrawer ao
// adicionar; o CartDrawerItems troca o .drawer__inner ao mudar quantidade e, no cartUpdate, o
// cart-drawer-items e o .cart-drawer__footer de novo — e o product-form publica o cartUpdate ANTES
// do renderContents. Não dá para confiar em evento: um MutationObserver no #CartDrawer (e na classe
// da própria gaveta, que ganha "active" ao abrir) agenda o trabalho para o próximo quadro.
// Preencher (frete, sugestões) só com a gaveta ABERTA: fechada ninguém vê, e buscar a cada página
// vista custaria chamadas por visitante. Os preenchedores são idempotentes.
// PÁGINA /cart: preenche na carga e a cada cartUpdate. No updateQuantity (e no "Adicionar" dos
// cards das sugestões) o evento sai DEPOIS da troca do DOM; num cartUpdate de outra origem (o
// external-refresh do standard-actions-override.js) é o onCartUpdate do Dawn que troca o
// <cart-items>, de forma assíncrona e DEPOIS do publish — nesse caminho o preenchimento lê a
// lista de antes, e o próximo cartUpdate acerta.
// BARRA INFERIOR: "Carrinho" abre a gaveta quando ela existe (fora da /cart); sem JS, é link.
const frete = await window.ArpineDS.importar("cartFrete");
const sugestoes = await window.ArpineDS.importar("cartSugestoes");

function preencher(raiz) {
  frete.preencher(raiz);
  sugestoes.preencher(raiz);
}

const gaveta = document.querySelector("cart-drawer");
const conteudo = document.getElementById("CartDrawer");

// "CARRINHO (N)": o onCartUpdate do Dawn não troca o título (fica fora de cart-drawer-items e do
// .cart-drawer__footer). O N vem das linhas — do value do servidor, não do que está sendo digitado.
function contar() {
  const alvo = conteudo.querySelector("[data-ds-cart-contagem]");
  if (!alvo) return;
  let total = 0;
  for (const campo of conteudo.querySelectorAll("[data-ds-cart-item] .quantity__input")) {
    total += parseInt(campo.getAttribute("value"), 10) || 0;
  }
  if (alvo.textContent !== String(total)) alvo.textContent = String(total);
}

if (gaveta && conteudo) {
  let agendado = false;
  const agendar = () => {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(() => {
      agendado = false;
      contar();
      if (gaveta.classList.contains("active")) preencher(conteudo);
    });
  };
  new MutationObserver(agendar).observe(conteudo, { childList: true, subtree: true });
  new MutationObserver(agendar).observe(gaveta, { attributes: true, attributeFilter: ["class"] });
  agendar();

  // Barra inferior (celular): "Carrinho" abre a gaveta.
  let gatilhoBarra = null;
  for (const link of document.querySelectorAll("[data-ds-abre-carrinho]")) link.setAttribute("aria-haspopup", "dialog");
  document.addEventListener("click", (e) => {
    const link = e.target.closest?.("[data-ds-abre-carrinho]");
    if (!link) return;
    e.preventDefault();
    gatilhoBarra = link;
    gaveta.open(link);
  });
  // Ao fechar, o Dawn devolve o foco ao gatilho ANTES de tirar o overflow-hidden do body — e a
  // barra inferior fica escondida enquanto ele existe (B1): o focus() cai num elemento invisível e
  // se perde. Devolvemos no quadro seguinte, com a barra já de volta.
  new MutationObserver(() => {
    if (gatilhoBarra && !gaveta.classList.contains("active")) {
      const alvo = gatilhoBarra;
      gatilhoBarra = null;
      requestAnimationFrame(() => alvo.focus());
    }
  }).observe(gaveta, { attributes: true, attributeFilter: ["class"] });
} else if (document.getElementById("main-cart-items")) {
  preencher(document);
  // subscribe e PUB_SUB_EVENTS são globais do Dawn (pubsub.js e constants.js, carregados antes)
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => preencher(document));
  }
}
